// @ngInject
function VariantsApiService(ResourcesService) {

    var endpoint = 'variants';

    return {
        getVariants: ResourcesService.apiFactory.get(endpoint),
        getVariant: ResourcesService.apiFactory.get(endpoint),
        getVariantGroupsByVariantId: ResourcesService.apiFactory.get(endpoint + '/variantgroups'),
        getVariantDetails: getVariantDetails,
        getAllVariantDetails: ResourcesService.apiFactory.get(endpoint + '/getallvariantdetails'),
        updateVariantDetails: ResourcesService.apiFactory.update(endpoint + '/details','VariantDetails')
    };

    function getVariantDetails(variantId, page, filter, pageSize) {
        var params = {};

        if (variantId && variantId > 0) {
            params.variantId = variantId;
        } else {
            // return error, we have to have a variantId
        }

        if (!_.isEmpty(filter)) {
            params.filter = filter;
        }

        if (page && page > 1) {
            params.page = page;
        }

        if (pageSize && pageSize > 0) {
            params.pageSize = pageSize;
        }

        var args = { params: params };

        console.log('getVariantDetails', args);

        return ResourcesService.apiFactory.get(endpoint + '/details')(args);
    }

}


angular.module('variants.api', [])
  .factory('VariantsApiService', VariantsApiService);

